import React from 'react';
import classNames from 'classnames';

import { paths } from 'client/shared/Paths';
import Link from '../Link';

import styles from './styles.sass';

const LegalTabNavigation = ({ pathname }) => (
  <ul className={styles.list}>
    <li
      className={classNames(styles.listItem, {
        [styles.listItemSelected]: pathname === paths.legal.tos,
      })}
    >
      <Link
        to={paths.legal.tos}
        className={classNames(styles.link, {
          [styles.selected]: pathname === paths.legal.tos,
        })}
        aria-current={pathname === paths.legal.tos ? 'page' : null}
      >
        Terms of Service
      </Link>
    </li>
    <li
      className={classNames(styles.listItem, {
        [styles.listItemSelected]: pathname === paths.legal.privacy,
      })}
    >
      <Link
        to={paths.legal.privacy}
        className={classNames(styles.link, {
          [styles.selected]: pathname === paths.legal.privacy,
        })}
        aria-current={pathname === paths.legal.privacy ? 'page' : null}
      >
        Privacy Policy
      </Link>
    </li>
    <li
      className={classNames(styles.listItem, {
        [styles.listItemSelected]: pathname === paths.legal.dmca,
      })}
    >
      <Link
        to={paths.legal.dmca}
        className={classNames(styles.link, {
          [styles.selected]: pathname === paths.legal.dmca,
        })}
        aria-current={pathname === paths.legal.dmca ? 'page' : null}
      >
        DMCA
      </Link>
    </li>
  </ul>
);

export { LegalTabNavigation };
